import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSolidCircle = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M512 1024c282.769 0 512-229.231 512-512s-229.231-512-512-512c-282.769 0-512 229.231-512 512s229.231 512 512 512z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgSolidCircle);
export default ForwardRef;
